<template>
  <div class="animated fadeInRight ecommerce">
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="swatchShopType({ shopTypeId: '', typeName: '全部' })"
              :class="{ 'selected': aShopInfo.conditions.shopType === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in aShopInfo.shopTypes" :key="index"
              @click="swatchShopType(item)"
              :class="{ 'selected': aShopInfo.conditions.shopType == item.shopTypeId }">
              {{ item.typeName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card class="ibox">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('aShop.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="aShopInfo.conditions.shopName" :placeholder="$t('aShop.shopName')" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="aShopInfo.conditions.state" :placeholder="$t('aShop.selectStatus')"
                style="width:100%">
                <el-option :label="$t('common.all')" value=""></el-option>
                <el-option :label="$t('aShop.approved')" value="002"></el-option>
                <el-option :label="$t('aShop.rejected')" value="003"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="aShopInfo.conditions.merchantId" :placeholder="$t('aShop.selectMerchant')"
                style="width:100%">
                <el-option :label="$t('common.all')" value=""></el-option>
                <el-option v-for="item in aShopInfo.merchants" :key="item.storeId" :label="item.name"
                  :value="item.storeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="_queryOrdersMethod()">
                {{ $t('aShop.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="ibox">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('aShop.shopInfo') }}</span>
          </div>
          <div class="">
            <el-table :data="aShopInfo.shops" border style="width: 100%">
              <el-table-column prop="shopLogo" :label="$t('aShop.shopLogo')" align="center">
                <template slot-scope="scope">
                  <img v-if="scope.row.shopLogo" :src="scope.row.shopLogo"
                    style="width: 60px; height: 60px; border-radius: 5px;">
                  <img v-else src="/img/noPhoto.jpg" style="width: 60px; height: 60px; border-radius: 5px;">
                </template>
              </el-table-column>
              <el-table-column prop="shopName" :label="$t('aShop.shopName')" align="center">
              </el-table-column>
              <el-table-column prop="shopTypeName" :label="$t('aShop.shopType')" align="center">
              </el-table-column>
              <el-table-column prop="storeName" :label="$t('aShop.merchantName')" align="center">
              </el-table-column>
              <el-table-column prop="storeAddress" :label="$t('aShop.merchantAddress')" align="center">
              </el-table-column>
              <el-table-column prop="storeTel" :label="$t('aShop.contactNumber')" align="center">
              </el-table-column>
              <el-table-column prop="stateName" :label="$t('aShop.shopStatus')" align="center">
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('aShop.createTime')" align="center">
              </el-table-column>
              <el-table-column :label="$t('aShop.operation')" align="center">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button size="mini" @click="_openShopWithdrawModel(scope.row)" v-if="scope.row.canApproveCommunity">
                      {{ $t('aShop.withdraw') }}
                    </el-button>
                    <el-button size="mini" type="primary" @click="_openAdminUpdateShop(scope.row)">
                      修改
                    </el-button>
                    <el-button size="mini" @click="_openShopDetail(scope.row)">
                      {{ $t('aShop.detail') }}
                    </el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @current-change="handleCurrentChange" :current-page="aShopInfo.conditions.page"
              :page-size="aShopInfo.conditions.row" layout="total, prev, pager, next" :total="aShopInfo.total">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <shop-withdraw ref="shopWithdraw" @refresh="_queryOrdersMethod"></shop-withdraw>
    <admin-update-shop ref="adminUpdateShop" @refresh="_queryOrdersMethod"></admin-update-shop>
  </div>
</template>

<script>
import { queryShopsByAdmin, listShopTypes } from '@/api/shop/shopApi'
import { listStores } from '@/api/admin/merchantManage/merchantManageApi'

import ShopWithdraw from '@/components/admin/shopWithdraw/shopWithdraw'
import AdminUpdateShop from '@/components/admin/adminUpdateShop/adminUpdateShop'

export default {
  name: 'AShop',
  components: {
    ShopWithdraw,
    AdminUpdateShop
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      aShopInfo: {
        shops: [],
        shopTypes: [],
        merchants: [],
        total: 0,
        records: 1,
        orderDetail: false,
        conditions: {
          shopName: '',
          shopType: '',
          state: '',
          appId: '',
          merchantId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listShopTypes()
    this._listMerchants()
    this._listAShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listAShops(val, this.DEFAULT_ROWS)
    },
    _listAShops(_page, _rows) {
      this.aShopInfo.conditions.page = _page
      this.aShopInfo.conditions.row = _rows
      queryShopsByAdmin(this.aShopInfo.conditions)
        .then(response => {
          this.aShopInfo.total = response.total
          this.aShopInfo.records = response.records
          this.aShopInfo.shops = response.data
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    swatchShopType(_shopType) {
      this.aShopInfo.conditions.shopType = _shopType.shopTypeId
      this._listAShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _listShopTypes() {
      const params = {
        page: 1,
        row: 100
      }
      listShopTypes(params)
        .then(response => {
          this.aShopInfo.shopTypes = response.data
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    _queryOrdersMethod() {
      this._listAShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _openShopWithdrawModel(_shop) {
      this.$refs.shopWithdraw.open(_shop)
    },
    _listMerchants() {
      const params = {
        page: 1,
        row: 100,
        storeTypeCd: '800900000005'
      }
      listStores(params)
        .then(response => {
          this.aShopInfo.merchants = response.data
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    _openShopDetail(_shop) {
      window.open('/#/pages/shop/aShopDetail?shopId=' + _shop.shopId)
    },
    _openAdminUpdateShop(_shop) {
      this.$refs.adminUpdateShop.open(_shop)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.border-radius {
  border-radius: 4px;
}

.margin-xs-r {
  margin-right: 5px;
}


.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
}
</style>